export const COMMON_COLUMN_WIDTH = {
  DATE: 190,
  TAG: 200,
  ACTIONS: 120,
  DRAG: 48,
} as const
